import React from 'react';
import useNetwork from '@/hooks/useNetwork';
import useRefLink from '@/hooks/useRefLink';
import useSelectedLanguage from '@/hooks/useSelectedLanguage';

const HooksConnectComponent: React.FC = () => {
    useSelectedLanguage();
    useNetwork();
    useRefLink();
    return null;
};

export default HooksConnectComponent;
